import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function getCarByLicensePlateAndCompany(licensePlate) {
  const result = await axios
    .get(
      `${CATALOGO_ENDPOINT}/getByPatentAndCompany/${licensePlate}`
    )

  return result?.data
}
